<template>
  <span
    class="premium"
    :class="{'inline' : inline == true, 'block': inline != true}"
    v-if="($store.getters.getPackage != 'premium' )"
    v-tooltip.top="$t('Upgrade to Premium Plan')"
  >
    <img src="/static/img/assets/_global/lock.svg" style="width: 20px" alt />
    <slot></slot>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    inline: {
      default: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
  }
}
</script>

<style lang="scss" scoped>
.premium {
  .simple-svg-wrapper {
    // background: white;
    display: inline-block;
  }
  // border-radius: 50%;
  // color: white;
  // padding: 0px 6px 4px 6px;
  // font-size: 9px;
  // height: 21px;
  // i{
  //     font-size: 9px;
  //     line-height: 9px;
  //     position: relative;
  //     top: 0;
  //     vertical-align: super;
  // }
  &.inline {
    // padding: 3px 6px 5px 6px;
    // top: -3px;
    position: relative;
    // vertical-align: middle;
    img {
      vertical-align: bottom;
    }
  }
  &.block {
    margin-top: -10px;
    margin-right: -6px;
    position: absolute;
    top: 0;
    right: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/elements/PremiumLock.vue